// import { useEffect, useState } from "react";
// import axios from "axios";

// const useGetSubDepartments = (departmentId) => {
//     const [subDeptOptions, setSubDeptOptions] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const fetchSubDepartments = async () => {
//         if (!departmentId) return;

//         setLoading(true);
//         try {
//             const payload = {
//                 departmentId: departmentId,
//             };

//             const res = await axios.post(
//                 process.env.REACT_APP_BASE_URL + "/subdepartment/getAllsubDepartment",
//                 payload
//             );

//             const data = res?.data?.data || [];

//             const formatted = data.map((item) => ({
//                 label: item.subDepartmentName,
//                 value: item.subDepartmentId,
//             }));

//             setSubDeptOptions(formatted);

//         } catch (err) {
//             console.log("SubDepartment API Error", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchSubDepartments();
//     }, [departmentId]);

//     return { subDeptOptions, loading };
// };

// export default useGetSubDepartments;


import { useEffect, useState } from "react";
import axios from "axios";

const useGetSubDepartments = (departmentId, fetchAll = false) => {
    const [subDeptOptions, setSubDeptOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSubDepartments = async () => {
        if (!fetchAll && !departmentId) return;

        setLoading(true);
        try {
            let payload = {};

            if (!fetchAll) {
                payload = {
                    departmentId: departmentId,
                };
            }

            const res = await axios.post(
                process.env.REACT_APP_BASE_URL + "/subdepartment/getAllsubDepartment",
                payload
            );

            const data = res?.data?.data || [];

            const formatted = data.map((item) => ({
                label: item.subDepartmentName,
                value: item.subDepartmentId,
            }));

            setSubDeptOptions(formatted);
        } catch (err) {
            console.log("SubDepartment API Error", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubDepartments();
    }, [departmentId, fetchAll]);

    return { subDeptOptions, loading };
};

export default useGetSubDepartments;